import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("atl_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const viewAs = localStorage.getItem("atl_view_as");
  if (viewAs) config.headers["X-View-As-User"] = viewAs;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("atl_token");
      localStorage.removeItem("atl_user");
      localStorage.removeItem("atl_view_as");
      // Never force-redirect while the OAuth callback is in flight — the
      // AuthCallback component owns the recovery path (retry button).
      // Also skip if the user is already on /login or an OAuth hash is still
      // present on this page.
      const path = window.location.pathname || "";
      const onCallback = path.startsWith("/auth/callback");
      const onLogin = path.endsWith("/login") || path.startsWith("/privacy");
      const hasOauthHash = window.location.hash?.includes("session_id=");
      if (!onCallback && !onLogin && !hasOauthHash) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);
